export default "__VITE_ASSET__rVJIhjZ$__"